import React from "react"

export function useQuery() {
    const search = window.location.search

    return React.useMemo(() => new URLSearchParams(search), [search])
}